import React, {memo, useEffect, useMemo} from 'react';
import {Box} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {
    currentStepSelector,
    formSummarySelector,
    receiverInformationStepSelector
} from '../../../store/modules/steps/selectors';
import {CustomSelectTypeOptions, FormStep, FormStepProps, StepsState} from '../../../model/global';
import CustomFormField from '../../FormControls/CustomFormField';
import {CustomFormFieldState} from '../../FormControls/CustomFormField/CustomFormField';
import {getFormSummaryField} from '../../utils';
import {getFormControlInitialState} from '../../utils';
import {stepsActions} from '../../../store/modules/steps/reducer';



const CustomerInformation: React.FC<FormStepProps> = ({data: {stepTemplate}}) => {

    const dispatch = useDispatch()
    const step = useSelector(currentStepSelector) as FormStep<'customerAddress'>

    const summary = useSelector(formSummarySelector) as StepsState['formSummary']
    const stepErrors = summary.validationErrors[step.stepTemplate]



    // initialise the step data once
    useEffect(() => {
        // don't re-init fields
        if (summary.initialized[stepTemplate]) return;

        const initialData: Record<string, CustomFormFieldState> = {};

        const partners = summary.steps.MAIN_ENQUIRY.target_group?.originalField['options']
        const requiredPartners: Array<string> = []
        if (partners) {
            partners.forEach((partner: CustomSelectTypeOptions) => {
                if (partner.options && partner.options[0].label === 'companyFieldRequired' && partner.options[0].value === 'true') {
                    if (typeof partner.value === "string") {
                        requiredPartners.push(partner.value)
                    }
                }
            })
        }

        // build customer address fields
        step.stepData.fields.customerAddress.forEach(element => {
            if (!element || !element.name) return;
            const item = getFormControlInitialState(element.name, step.stepData.fields.customerAddress);
            if (item && item.name === 'customer_company') {
                item.required = !!(summary.steps.MAIN_ENQUIRY.target_group && requiredPartners.includes(summary.steps.MAIN_ENQUIRY.target_group.value));
            }

            const value = summary.steps.CUSTOMER_INFORMATION
            if (item && value[item.name] && value[item.name]?.value) {
                item.value = value[item.name]?.value
            }

            if (item) initialData[element.name] = item
        })

        /*	// build commission address fields
            step.stepData.fields.commissionData.forEach(element => {

                if (!element || !element.name) return;
                const item = getFormControlInitialState(element.name, step.stepData.fields.commissionData);
                if (item && item.name === 'commission_company') {
                    item.required = !!(summary.steps.MAIN_ENQUIRY.target_group && requiredPartners.includes(summary.steps.MAIN_ENQUIRY.target_group.value));
                }

                const value = summary.steps.CUSTOMER_ADDRESS
                if (item && value[item.name] && value[item.name]?.value) {
                    item.value = value[item.name]?.value
                }

                if (item) initialData[element.name] = item
            })*/

        // build installer address fields
        /*	step.stepData.fields.installerData.forEach(element => {
                if (!element || !element.name) return;
                const item = getFormControlInitialState(element.name, step.stepData.fields.installerData);
                if (item) initialData[element.name] = item
            })*/

        dispatch(stepsActions.initializeStepPayloadValues({
            stepTemplate,
            stepPayload: initialData,
            initialize: true,
        }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        step.stepData.fields.customerAddress,
        stepTemplate,
        summary.initialized,
        summary.steps.MAIN_ENQUIRY.target_group
    ])

    const fieldChangeHandler = (event: CustomFormFieldState): void => {
        dispatch(stepsActions.updateStepPayloadValues({
            stepTemplate,
            stepPayload: event,
        }));
    }

    if (!step) return null

    // get the 2 checkbox fields
    const sumStepTemp = (item: string) => item ? summary.steps[stepTemplate][item] : undefined
    const commissionDataCheckbox = sumStepTemp('commission_data_checkbox') ? sumStepTemp('commission_data_checkbox') : undefined;

    // get redux main address fields
    const addressFields: CustomFormFieldState<any>[] = []
    step.stepData.fields.customerAddress.forEach(f => {
        if (!f.name) return;
        if (Object.keys(summary.steps[stepTemplate]).length === 0) return;
        const item = getFormSummaryField(summary, stepTemplate, f.name);
        item && addressFields.push({...item, required: item?.originalField?.required || false})
    })

    const commissionFields: CustomFormFieldState<any>[] = []
    /*	step.stepData.fields.commissionData.forEach(f => {
            if (!f.name) return;
            if (Object.keys(summary.steps[stepTemplate]).length === 0) return;
            const item = getFormSummaryField(summary, stepTemplate, f.name);
            item && commissionFields.push({ ...item, required: item?.originalField?.required || false })
        })*/
    const attributeOBJ = (field: any) => {
        return ({field, fieldErrors: stepErrors})
    }

    return (
        <React.Fragment>
            <Box>
                <fieldset className={'customer-address-fieldset'}>
                    <h2 className={'customer-address-fieldset-title'}>{step.stepData.fieldTranslations.customerAddress}</h2>
                    <div className="uk-grid-medium uk-grid uk-grid-stack">
                        {/* 1. ALL Customer Address fields */}
                        {addressFields?.map((field, key) => {
                            return <CustomFormField key={`comission-${key}`} {...attributeOBJ(field)}
                                                    onFieldChange={e => fieldChangeHandler(e)}/>
                        })}

                    </div>
                </fieldset>
            </Box>


            {/*<Box>
				<fieldset className={'customer-address-fieldset'}>
					<h2 className={'customer-address-fieldset-title'}>{step.stepData.fieldTranslations.installerData}</h2>
					<div className="uk-grid-medium uk-grid uk-grid-stack">
						 3. Installer Data (connected to checkbox 2)
						{installerFields?.map((field, key) => {
							return <CustomFormField key={`installer-${key}`} {...attributeOBJ(field)} onFieldChange={e => fieldChangeHandler(e)} />
						})}
					</div>
				</fieldset>
			</Box>*/}
        </React.Fragment>
    )
}
export default memo(CustomerInformation)
